import React, { useState, useEffect } from 'react';
import { useAuth } from '../../auth/workosAuth';
import Editor from './Editor';
import Code from '../Code';

export default function EditorToggle() {
  const { user } = useAuth();
  const [version, setVersion] = useState(
    localStorage.getItem('sqlEditorVersion') || 'v2'
  );

  // Listen for storage changes from Navbar toggle
  useEffect(() => {
    const handleStorageChange = () => {
      const newVersion = localStorage.getItem('sqlEditorVersion') || 'v2';
      setVersion(newVersion);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Wait for user to be loaded before deciding which editor to show
  if (!user) {
    return null;
  }

  // All users can access v1 or v2 based on preference
  return version === 'v1' ? <Editor /> : <Code />;
}
